import React, { useState } from "react";

import { Grid, GridColumn, GridRow, Input, List, ListItem, Segment } from "semantic-ui-react";
import SearchListVector from "../../assets/SearchListVector";
import { SmartTargetFilter } from "../../types/types";
import SmartTargetFilterItem from "../CustomImprovements/SmartTargets/SmartTargetFilterItem";
import Button from "../UI/Button/Button";
import Modal from "./Modal";

import "./SmartTargetFilterModal.scss";

interface SmartTargetFilterModalProps {
	onClose: () => void;
	onSaveFilters: (filters: SmartTargetFilter[]) => void;
	improvementState: SmartTargetFilter[];
	nested?: boolean;
}

export default function SmartTargetFilterModal({
	onClose,
	onSaveFilters,
	improvementState,
	nested = true,
}: SmartTargetFilterModalProps) {
	const [dirtyFilters, setDirtyFilters] = useState<SmartTargetFilter[]>(improvementState);
	const [searchValue, setSearchValue] = useState<string>("");

	const onCancel = () => {
		setDirtyFilters(improvementState);
		onClose();
	};

	const onSave = () => {
		onSaveFilters(dirtyFilters);
		onClose();
	};

	const updateFilterState = (filter: SmartTargetFilter, index: number) => {
		let updatedFilters = [...dirtyFilters];
		updatedFilters[index] = filter;
		setDirtyFilters(updatedFilters);
	};

	const isAllMeasuresSelected = (onlyCustom: boolean) => {
		if (onlyCustom) {
			const numSelected = dirtyFilters.filter(
				(filter) => filter.customImprovement.accepts_parameters && !filter.hidden
			).length;
			return (
				numSelected ===
				dirtyFilters.filter((filter) => onlyCustom && filter.customImprovement.accepts_parameters).length
			);
		}
		return dirtyFilters.filter((filter) => !filter.hidden).length === dirtyFilters.length;
	};

	const hideShowALl = (onlyCustom: boolean) => {
		const hideAll = isAllMeasuresSelected(onlyCustom);
		if (onlyCustom) {
			setDirtyFilters(
				dirtyFilters.map((f) => (f.customImprovement.accepts_parameters ? { ...f, hidden: hideAll } : f))
			);
		} else {
			setDirtyFilters(dirtyFilters.map((f) => ({ ...f, hidden: hideAll })));
		}
	};

	return (
		<Modal title={"Included Measures"} nested={nested} onClose={() => onClose()}>
			<Input
				placeholder="Search Measures..."
				icon={<SearchListVector className="search-icon" />}
				iconPosition="left"
				className="search-measures"
				onChange={(e) => {
					setSearchValue(e.target.value);
				}}
			/>
			<div className="button-row">
				<Button attached="left" onClick={() => hideShowALl(false)}>
					{isAllMeasuresSelected(false) ? "Hide" : "Show"} all
				</Button>
			</div>
			<Segment className="filter-item-list-container">
				<List>
					{dirtyFilters
						.filter((state) =>
							state.customImprovement.name.toLowerCase().includes(searchValue.toLowerCase())
						)
						.map((filter, index) => (
							<ListItem key={filter.customImprovement.id}>
								<SmartTargetFilterItem
									filterState={filter}
									setFilterState={(filterState) => updateFilterState(filterState, index)}
								/>
							</ListItem>
						))}
				</List>
			</Segment>
			<Grid>
				<GridRow>
					<GridColumn width={8}>
						<Button variant={"modal-secondary"} onClick={() => onCancel()}>
							Cancel
						</Button>
					</GridColumn>
					<GridColumn width={8}>
						<Button variant={"modal-primary"} onClick={() => onSave()}>
							Save Filters
						</Button>
					</GridColumn>
				</GridRow>
			</Grid>
		</Modal>
	);
}
